module.exports = __webpack_public_path__ + "static/update_dan_cammish-c1af1248e7cb0e19ecfbe7b346514f6c.jpg";